// extracted by mini-css-extract-plugin
module.exports = {"spotSelector":"spotMarkets_spotSelector__2i8It","spotRegionSelect":"spotMarkets_spotRegionSelect__2BVHc","regioneSelector":"spotMarkets_regioneSelector__19ee4"};